import PasswordChangerContainer from 'components/UserSettings/containers/PasswordChangerContainer/PasswordChangerContainer'
import React from 'react'

export const UserSettings: React.FC = () => {
  return <PasswordChangerContainer />
}
